// extracted by mini-css-extract-plugin
export default {"loadingBlock":"LoadingScreen_loadingBlock__Memtf","flip":"LoadingScreen_flip__bzTDi"};